import React, { useMemo } from 'react';
import { DisciplineLiveStatus, DisciplineVirtualStatus, SportCounterType } from '@om-fe/models';
import {
    SportsNavCounterType,
    SportsNavType,
    getCounterType,
    getSportsNavTopic,
    UseSportsNavStore,
    NavTopicStoreCreatorProps,
    useNavTopicStoreCreator,
    SportsNavOptions,
} from '@om-fe/widgets';

export function useNavVirtualSportsTopicStoreCreator(): UseSportsNavStore {
    const topic: string = getSportsNavTopic(SportsNavType.Virtual);

    const liveCounterType: SportCounterType | undefined = getCounterType(
        SportsNavType.Live,
        true,
        SportsNavCounterType.NumberOfEvents,
    );
    
    const upcomingCounterType: SportCounterType | undefined = getCounterType(
        SportsNavType.All,
        false,
        SportsNavCounterType.NumberOfEvents,
    );

    const topicDetails: NavTopicStoreCreatorProps = React.useMemo(() => {
        return {
            liveStatus: DisciplineLiveStatus.BOTH,
            virtualStatus: DisciplineVirtualStatus.VIRTUAL,
            liveCounterType,
            upcomingCounterType,
        };
    }, [liveCounterType, upcomingCounterType]);

    const topicOptions: SportsNavOptions = useMemo(() => {
        return {
            hasAllSports: false,
            sportsNavType: SportsNavType.Virtual,
        };
    }, []);

    return useNavTopicStoreCreator(
        topic,
        topicDetails,
        topicOptions,
    );
}
